import {createStyles} from '@material-ui/core';
import type {Theme} from '@material-ui/core/styles';
import * as colors from 'assets/theme/colors';

export default createStyles((theme: Theme) => ({
    colorPrimary: {
        fontSize: theme.typography.pxToRem(14),
        backgroundColor: `${colors.primary.A40} !important`,
    },
    barColorPrimary: {
        fontSize: theme.typography.pxToRem(14),
        backgroundColor: `${colors.neutrals.A10} !important`,
    },
}));
